/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Icon as ChromaIcon } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';

const IconWrapper = styled.div`
  .c-icon {
    font-size: 1em;
  }
`;

export const Icon = ({ ...props }) => (
  <IconWrapper>
    <ChromaIcon {...props} />
  </IconWrapper>
);

export default Icon;
